import { Injectable } from '@angular/core';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { HttpErrorResponse } from '@angular/common/http';
import { SubscriptionStatus } from '../../Reports/model/SubscriptionStatus';
import { RequestStatus } from '../../Reports/model/RequestStatus';
import { ErrorType, CustomError } from '../model/ErrorType';

@Injectable()
export class HttpUtility{

    parseVoid(r: Response): boolean {
        return true;
    }

    handleError(error: HttpErrorResponse) {

        let message = "An error has occurred. Please try again";

        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.          
          if(error.error == undefined || error.error == null){
            return new ErrorObservable(message);
          }

          return new ErrorObservable(error.error.message);
        }

        if(error.status == 401){
            setTimeout(() => {
                window.location.href = '/home';
            }, 3000);
            return new ErrorObservable(`UnAuthorized - Redirecting to Login Page...`);            
        }
        
        if (error.status == 403) {
            return new ErrorObservable(`${error.statusText} - The user is not authorized to perform this action`);
        }

        if (error.status == 404) {
            return new ErrorObservable(error);
        }

        if(error.status == 500){
            return new ErrorObservable(`${error.statusText} - ${message}`);
        }

        if(error.status == 400){

            if(error["_body"]==undefined || error["_body"] == null){
                return new ErrorObservable(message);
            }

            let body = JSON.parse(error["_body"]);
            if(body.hasOwnProperty("requestID")){
                if(body['status']==RequestStatus.UnProcessable){
                    var UnProcessableError = new CustomError();
                    UnProcessableError.errorType=ErrorType.UnProcessable;   
                    UnProcessableError.Count = body['recordsCount']                 
                    return new ErrorObservable(UnProcessableError);
                }
            }

            let errors=[];

            for (var fieldName in body) {
                if(fieldName=="0"){
                    return new ErrorObservable(body);
                }

                if (body.hasOwnProperty(fieldName)) {
                    errors.push(body[fieldName]);
                }
            }

            return new ErrorObservable(errors.join("\n"));
        }
        
        return new ErrorObservable(message);
      }
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/service/HttpUtility.ts